import { DynamicStatSchemaResource } from 'app/shared/resources';
import ImsObjectCollection from './ims_object_collection.service';
import { DynamicStatSchema } from './dynamic_stat_schema';
import Constant from 'app/shared/utilities/constant';

import { StartupRegistry } from 'app/startup/registry/registry';
import { ILocalStorageService } from 'angular-local-storage';
import { UserGeneratedConfigService } from 'app/config/user_generated_config.service';

export class DynamicStatSchemaCollection extends ImsObjectCollection<DynamicStatSchema> {
    private _userGeneratedConfigService: UserGeneratedConfigService;

    constructor(
        startUpRegistry: StartupRegistry,
        localStorageService: ILocalStorageService,
        $interval: unknown,
        userGeneratedConfigService: UserGeneratedConfigService,
    ) {
        // Sets broadcastIfEmpty to true so that even if there are no dynamic stats, the required processing still runs
        // Have no refreshrate since views should only update on reloading of the page
        super(
            startUpRegistry,
            localStorageService,
            $interval,
            DynamicStatSchemaResource,
            DynamicStatSchema,
            {
                onDemand: false,
                broadcastWhenEmpty: true,
                refreshRate: 0,
            },
        );

        this._userGeneratedConfigService = userGeneratedConfigService;
    }

    /**
     * Filters out dynamic stat schemas based on the description of the schema and the
     * logged in user. The description field is optional, so any schema without a
     * description will NOT be filtered out.
     * @param schemas
     * @returns An object of dynamic stat schemas with items filtered out.
     */
    _filterInternal(schemas: DynamicStatSchema[]): DynamicStatSchema[] {
        return schemas;
    }

    /**
     * Gets an array of all the dynamic schemas that are meant for the given object(asset or ip device) and type
     * @param objectType an asset or an ip device
     * @param typeId either an asset type of and ip device type
     */
    getSchemas(objectType: string, typeId: number): DynamicStatSchema[] {
        let schemaNameList;

        // just in case somebody has overriden dynamicSchemaTypeDict and doesn't have the minimum data shape
        try {
            schemaNameList =
                this._userGeneratedConfigService.configData.dynamicSchemaTypeDict[objectType][
                    typeId
                ];
        } catch (e) {
            schemaNameList = [];
        }

        if (!schemaNameList) {
            return [];
        }

        return this.getAllAsArray().filter(
            (schema) =>
                objectType === schema.parent_type && schemaNameList.includes(schema.display_name),
        );
    }
}
